import React, { useState } from "react";

import googleIcon from "./images/google-icon.webp";
import { Form, Card, Button, Alert, Spinner } from "react-bootstrap";
import "./GenerateReport.css";
import Navbar from "./Navbar";

const GenerateReport = () => {
  const [isGoogleConnected, setIsGoogleConnected] = useState(false);
  const [authUrl, setAuthUrl] = useState([]);
  const [custDetails, setCustDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshToken, setRefreshToken] = useState("");
  const [pdfLink, setPdfLink] = useState("");
  const [custId, setCustId] = useState([]);
  const [copied, setCopied] = useState(false);

  const handleCustChange = (e) => {
    setCustId([e.target.value, e.target.options[e.target.selectedIndex].text]);
  };

  const handleGoogleConnect = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}api/connect/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token c0a95520160fa9d2fa26552543c48fb99e7e8d17`,
          },
        },
      );
      const url = await response.text();
      let urlObj = new URL(url);
      urlObj.searchParams.set(
        "redirect_uri",
        `${process.env.REACT_APP_GOOGLE_REDIRECT_URI}`,
      );
      let updatedUrl = urlObj.toString();

      // Open the popup after adding the listener
      const authPopup = window.open(
        updatedUrl,
        "authPopup",
        "width=500,height=600",
      );

      if (!authPopup) {
        setIsLoading(false);
        console.error("Popup blocked. Please allow popups for this site.");
      } else {
        // Poll the popup window for changes in its URL
        const checkPopup = setInterval(async () => {
          try {
            if (!authPopup || authPopup.closed) {
              setIsLoading(false);
              clearInterval(checkPopup);
              return;
            }

            // Read the URL from the popup
            const urlParams = new URLSearchParams(authPopup.location.search);
            const code = urlParams.get("code");
            const passthrough_val = urlParams.get("state");

            if (code && passthrough_val) {
              clearInterval(checkPopup);
              setAuthUrl([code, passthrough_val]);
              authPopup.close();
              const getToken = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}api/get_google_token_new/`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    google_access_code: code,
                    redirect_uri: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
                  }),
                },
              );

              const refreshToken = await getToken.json();
              // console.log(refreshToken);
              setRefreshToken(refreshToken);

              const getCustomers = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}api/get_google_token_new/?refresh_token=${refreshToken["refresh_token"]}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                  },
                },
              );

              const customers = await getCustomers.json();
              if (customers.length > 0) {
                setIsGoogleConnected(true);
                setCustDetails(customers);
                setIsLoading(false);
              }
            }
          } catch (error) {
            // Ignoring cross-origin errors until the popup redirects to your domain
          }
        }, 500); // Check every 500ms
      }
    } catch (e) {
      console.error(e);
    }
    // setIsGoogleConnected(true);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // reset after 2s
    });
  };

  const handleAccountSubmit = async (e) => {
    e.preventDefault();
    // console.log("cust: ",custId,"refresh: ",refreshToken);
    setIsLoading(true);
    const getPdf = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}api/save_project_and_token/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          refresh_token: refreshToken["refresh_token"],
          customer_id: custId[0],
          customer_name: custId[1],
        }),
      },
    );
    let Link = await getPdf.json();
    setPdfLink(Link["token"]);
    setIsLoading(false);
  };

  return (
    <>
      <Navbar />
      <div className="main-container">
        <Card className="display-card">
          <Card.Header>
            <Card.Title as={"h2"}>Get You Token</Card.Title>
          </Card.Header>
          <Card.Body>
            {isLoading ? (
              <Alert className="loading-alert" variant="primary">
                <Spinner animation="border" role="status"></Spinner> Loading
                Please wait...
              </Alert>
            ) : isGoogleConnected ? (
              pdfLink !== "" ? (
                <>
                  <div>
                    <span style={{ fontWeight: 600 }}>Your Token: </span>
                    {pdfLink}
                  </div>
                  <button
                    onClick={() => handleCopy(pdfLink)}
                    className={`btn mt-2 mb-3 btn-primary`}
                  >
                    {copied ? "Copied!" : "Copy"}
                  </button>
                </>
              ) : (
                <form onSubmit={handleAccountSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Select Ac</Form.Label>
                    <Form.Select
                      onChange={handleCustChange}
                      aria-label="Select Account"
                      value={custId[0]}
                      required
                    >
                      <option value="">Select Account</option>
                      {custDetails.map((customer, index) => {
                        return (
                          <option key={index} value={customer["customer_id"]}>
                            {customer["description"]}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                  <button type="submit" className={`btn mb-3 btn-primary`}>
                    Generate
                  </button>
                </form>
              )
            ) : (
              <>
                <p>
                  Please use your email id which has access to google ads
                  account
                </p>
                <Button
                  variant="primary"
                  onClick={handleGoogleConnect}
                  className={`mb-3 btn-google`}
                >
                  <img src={googleIcon} alt="connect button" />
                  Sign in with Google
                </Button>
                {authUrl.join(", ")}
              </>
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default GenerateReport;
